import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import Languages from '../Languages/Languages'
import InstructionMode from './components/InstructionMode'
import PageModeSwitcher from './components/PageModeSwitcher'
import AboutMode from './components/AboutMode'
import Layout from './components/Layout'
import SocialButtons from '../SocialButtons/SocialButtons'
import './IntroRoom.scss'

const IntroRoom = ({ show, activeSoundsLoaded }) => {
  const { t } = useTranslation('IntroRoom')
  const [showInstruction, setPageMode] = useState(false)
  let location = useLocation()
  const query = location.search && location.search.replace('?name=', '')

  const togglePageMode = () => {
    setPageMode(!showInstruction)
  }
  return (
    <Layout show={show}>
      <div style={{ position: 'absolute', right: 0, fontSize: '18px' }}>
        <div>{t('projectName')}</div>
        <SocialButtons />
      </div>
      <Languages />
      {showInstruction ? (
        <InstructionMode close={togglePageMode} t={t} />
      ) : (
        <AboutMode t={t} query={query} activeSoundsLoaded={activeSoundsLoaded} />
      )}
      <PageModeSwitcher showInstruction={showInstruction} togglePageMode={togglePageMode} t={t} />
    </Layout>
  )
}

export default IntroRoom
